{
  "sv-SE": {
    "model": {
      "profile": {
        "id": "Användar-ID",
        "userName": "Användarnamn",
        "email": "E-postadress",
        "emailConfirmed": "E-postadressen har bekräftats.",
        "phoneNumber": "Telefonnummer",
        "phoneNumberConfirmed": "Telefonnummern har bekräftats.",
        "twoFactorEnabled": "Tvåfaktorsautentisering aktiverad.",
        "lockoutEnd": "Spärrtidens slutdatum.",
        "lockoutEnabled": "Låsningsfunktion aktiverad.",
        "accessFailedCount": "Antal misslyckade inloggningsförsök",
        "firstName": "Förnamn",
        "lastName": "Efternamn",
        "picture": "Profilbild",
        "organisationName": "Organisation",
        "name": "Namn",
        "roles": "Roller"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Bekräftad"
      },
      "action": {
        "resetPassword.tooltip": "Skicka instruktioner för återställning av lösenord till användaren via e-post."
      },
      "message": {
        "resetPassword.success": "Ett e-postmeddelande har skickats till användaren med instruktioner om hur hen återställer sitt lösenord."
      }
    }
  }
}